// extracted by mini-css-extract-plugin
export default {"list-item-content":"list-item-content--V0wV9","name":"name--H_gLb","honorific":"honorific--YjdqB","role":"role--Paalg","primary-contact-icon":"primary-contact-icon--AZjx3"};